import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20flowing%20shapes%20in%20coral%20and%20amber%20tones%2C%20dreamy%20atmospheric%20texture%2C%20modern%20minimalist%20design%2C%20elegant%20inviting%20composition&width=1800&height=600&seq=cta-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 via-primary-800/70 to-primary-900/80"></div>
      <div className="relative z-10 text-center px-4 w-full">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">{t('cta.title')}</h2>
        <p className="text-sm md:text-base text-background-50/80 mb-6">{t('cta.subtitle')}</p>
        <Link
          to="/about"
          className="inline-flex px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
        </Link>
      </div>
    </section>
  );
}